import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ModalBody } from "reactstrap";

import {
    setStandAlonePrintingStationPrints,
    setPrintingOptionsSpecialCharacters,
    setPendingBarcodeChecked,
    setPendingBarcodePosition,
    setPendingQrCodeChecked,
    setPendingQrCodePosition,
    setOrderBarcodeChecked,
    setOrderBarcodePosition,
    setOrderQrCodeChecked,
    setOrderQrCodePosition,
    resetStore,
    setPaperlessTicket,
    setQrCodeType,
    setQrCodeUrl,
    setQrCodeImage,
    storeDivers,
} from "./Hook/store";

import { setDivers } from "../store";

import UserCard from "./Hook/UserCard";
import { PrinterFooter } from "../PrinterFooter";

import "@assets/swal.css";
import "@assets/theme.css";
import "../index.css";

type DiversType = {
    rowData: any;
    oneShop: boolean;
};

export default function Divers({ rowData }: DiversType) {
    const { t } = useTranslation();
    const {
        printingOptionsSpecialCharacters,
        pendingBarcodeChecked,
        pendingBarcodePosition,
        pendingQrCodeChecked,
        pendingQrCodePosition,
        orderBarcodeChecked,
        orderBarcodePosition,
        orderQrCodeChecked,
        orderQrCodePosition,
        paperlessTicket,
        qrCodeType,
        qrCodeUrl,
        qrCodeImage,
    } = useSnapshot(storeDivers);

    useEffect(() => {
        if (rowData["divers"] !== undefined)
            if (Object.keys(rowData["divers"]).length > 0) {
                if (rowData["divers"]?.alone_printing) {
                    setStandAlonePrintingStationPrints(
                        rowData["divers"].alone_printing.station_prints
                    );
                }
                if (rowData["divers"]?.printing_options) {
                    setPrintingOptionsSpecialCharacters(
                        rowData["divers"].printing_options.special_characters
                    );
                }

                if (rowData["divers"]?.Code) {
                    const code = rowData["divers"].Code;
                    if (code.pending !== undefined) {
                        setPendingBarcodeChecked(
                            code.pending.barcodeChecked ?? false
                        );
                        setPendingBarcodePosition(
                            code.pending.barcodePosition ?? "2"
                        );
                        setPendingQrCodeChecked(
                            code.pending.qrCodeChecked ?? false
                        );
                        setPendingQrCodePosition(
                            code.pending.qrCodePosition ?? "2"
                        );
                    }
                    if (code.order !== undefined) {
                        setOrderBarcodeChecked(
                            code.order.barcodeChecked ?? false
                        );
                        setOrderBarcodePosition(
                            code.order.barcodePosition ?? "2"
                        );
                        setOrderQrCodeChecked(
                            code.order.qrCodeChecked ?? false
                        );
                        setOrderQrCodePosition(
                            code.order.qrCodePosition ?? "2"
                        );
                        if (code.order.qr_code_config) {
                            setQrCodeType(
                                code.order.qr_code_config.type || "url"
                            );
                            setQrCodeUrl(code.order.qr_code_config.url || "");
                            setQrCodeImage(
                                code.order.qr_code_config.image || ""
                            );
                        }
                    }
                }
                if (rowData["divers"]?.paperless_ticket) {
                    setPaperlessTicket(
                        rowData["divers"].paperless_ticket
                            .paperless_ticket_custom
                    );
                }
            }
    }, [rowData, rowData?.divers]);

    useEffect(() => {
        const data: any = {
            printing_options: {
                special_characters: printingOptionsSpecialCharacters,
            },
            Code: {
                pending: {
                    barcodeChecked: pendingBarcodeChecked,
                    barcodePosition: pendingBarcodePosition,
                    qrCodeChecked: pendingQrCodeChecked,
                    qrCodePosition: pendingQrCodePosition,
                    qr_code_config: {
                        type: "",
                        url: "",
                        image: "",
                    },
                },
                order: {
                    barcodeChecked: orderBarcodeChecked,
                    barcodePosition: orderBarcodePosition,
                    qrCodeChecked: orderQrCodeChecked,
                    qrCodePosition: orderQrCodePosition,
                    qr_code_config: {
                        type: qrCodeType,
                        url: qrCodeUrl,
                        image: qrCodeImage,
                    },
                },
            },
            paperless_ticket: {
                paperless_ticket_custom: paperlessTicket,
            },
            qr_code_config: {
                type: qrCodeType,
                url: qrCodeUrl.trim(),
                image: qrCodeImage,
            },
        };
        setDivers(data);
    }, [
        printingOptionsSpecialCharacters,
        pendingBarcodeChecked,
        pendingBarcodePosition,
        pendingQrCodeChecked,
        pendingQrCodePosition,
        orderBarcodeChecked,
        orderBarcodePosition,
        orderQrCodeChecked,
        orderQrCodePosition,
        paperlessTicket,
        qrCodeType,
        qrCodeUrl,
        qrCodeImage,
    ]);

    return (
        <React.Fragment>
            <ModalBody style={{ height: "730px", overflow: "hidden" }}>
                <div className="px-3 pt-2">
                    <h4 style={{ fontSize: "24px" }}>{t("Various")}</h4>
                </div>
                <UserCard />
            </ModalBody>
            <PrinterFooter rowData={rowData} resetStore={resetStore} />
        </React.Fragment>
    );
}
